import { Type } from '@angular/core';
import { defer, Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

/** A helper function used for lazy loading component */
export function lazyComponent<T>(
  factory: () => PromiseLike<Type<T>>,
): Observable<Type<T>> {
  return defer(() => factory()).pipe(
    shareReplay({ bufferSize: 1, refCount: false }),
  );
}
